import "./App.css";
import ActivationSection from "./Components/ActivationSection";
import BenefitsSection from "./Components/BenefitsSection";
import CtaSection from "./Components/CtaSection";
import FaqSection from "./Components/FaqSection";
import Features from "./Components/Features";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import Hero from "./Components/Hero";
import SecuritySection from "./Components/SecuritySection";
import StepsOverview from "./Components/StepsOverview";

function App() {
  return (
    <div className="app">
      <Header />
      <main>
        <Hero />
        <Features />
        <BenefitsSection />
        <SecuritySection />
        <StepsOverview />
        <ActivationSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
